import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const studySubjectsWsApi = createApi({
  reducerPath: 'studySubjectsWsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getStudySubjectsWs: builder.query({
      query: () => ({
        url: urls.studySubjectsWs,
      }),
    }),
  }),
});

export const { useGetStudySubjectsWsQuery } = studySubjectsWsApi;
